import {
  createColumn,
  // createViewAction,
  formatDate,
  useUserRole,
  // getRegister,
} from "../../utils/helpers";
// import { FormActions } from "../../components/common/FormActions";
// import { URL_WALLET_TRANSFERS } from "../../utils/urls";
import { TransactionStatusTag } from "../../components/common/registerUtils";
import { ADMIN } from "../../utils/constants";
import { useEffect, useState } from "react";

export const useWalletTransfers = () => {
  const role = useUserRole();
  const [userRole, setUserRole] = useState<string>(role ?? "");

  useEffect(() => {
    if (role) {
      setUserRole(role);
    }
  }, [role]);

  const tableColumns = () => [
    createColumn("transaction_id", true, "Transaction ID"),
    createColumn("customer_number", true, "Customer Number"),
    createColumn("tran_type", true, "Transaction Type"),
    createColumn("amount", true, "Amount"),
    createColumn("final_status", true, "status"),
    createColumn("payment_date", true, "Payment Date"),
    // createColumn("actions", false, "Actions"),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        customer_number:
          userRole === ADMIN ? item.customer_no : item.customer_number,
        final_status: <TransactionStatusTag status={item?.final_status} />,
        payment_date: formatDate(item?.payment_date),
        tran_type: userRole === ADMIN ? item.tran_type : item.item_name,
      };
    }),
  ];

  return { tableData, tableColumns };
};
